import { h } from 'preact';
import Plus from '../utils/icon/plus.svg';
import Minus from '../utils/icon/minus.svg';

const ProductQuantity = ({ quantity, changeQuantity, maxQuantity }) => {
  const setQty = (qty) => {
    if (maxQuantity && qty > maxQuantity) {
      changeQuantity(maxQuantity);
      return;
    }
    if (qty && qty < 1) {
      changeQuantity(1);
      return;
    }
    changeQuantity(qty);
  };
  const onBlur = () => {
    if (!quantity) {
      setQty(1);
    }
  };

  return (
    <div className="relative" onBlur={onBlur} tabIndex={-1}>
      <button
        type="button"
        aria-label="Decrease quantity"
        className="absolute top-4 left-[13px]"
        onClick={() => setQty(quantity - 1)}
      >
        <Minus />
      </button>
      <input
        type="number"
        aria-label="Quantity input"
        className="cta-large input max-w-[85px] laptop:max-w-[92px] text-center text-black-3 h-11 appearance-non !font-medium !leading-[1] !tracking-[1px] !text-[13px] px-[30px] bg-transparent"
        value={quantity}
        onChange={(e) => setQty(e.target.value)}
      />
      <button
        type="button"
        aria-label="Increase quantity"
        className="absolute top-[15px] right-3"
        onClick={() => setQty(quantity + 1)}
      >
        <Plus />
      </button>
    </div>
  );
};

export default ProductQuantity;
